export const overflowButtonStyle = {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden", // Options: visible, hidden, scroll, auto
    display: "inline-block", // Options: block, inline, inline-block, flex, grid, etc.
};

export const centerVericalAlignIconStyle = {
    verticalAlign: "sub",
};

export const GREEN_COLOR = "#509153";
export const RED_COLOR = "#d32f2f";
export const YELLOW_COLOR = "#EDBD01";

export const getStyleForSLACell = (sla, returnOnlyColorValue = false) => {
    let color = YELLOW_COLOR;
    if (sla > 2) {
        color = RED_COLOR;
    } else if (sla <= 0) {
        color = GREEN_COLOR;
    }
    return returnOnlyColorValue ? color : { backgroundColor: color };
};

export const getStyleForTicketResponseTimeCell = (responseTime, returnOnlyColorValue = false) => {
    let color = YELLOW_COLOR;
    if (responseTime > 24) {
        color = RED_COLOR;
    } else if (responseTime <= 2) {
        color = GREEN_COLOR;
    }
    return returnOnlyColorValue ? color : { backgroundColor: color };
};

export const getNpsIndicatorColor = (npsIndicator) => {
    if (!npsIndicator) {
        return null;
    }

    const goodIndicatorValue = 50.0;
    const badIndicatorValue = 0.0;

    let color = YELLOW_COLOR;
    if (npsIndicator > goodIndicatorValue) {
        color = GREEN_COLOR;
    } else if (npsIndicator <= badIndicatorValue) {
        color = RED_COLOR;
    }
    return color;
};

export const BLACK_TEXT_FIELD_INPUT_STYLE = {
    "-webkit-text-fill-color": "black",
};


export const NO_BORDER_TEXT_FILED_STYLE = {
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
        border: "none", // Remove the outline border
        },
        "&:hover fieldset": {
        border: "none", // Remove on hover
        },
        "&.Mui-focused fieldset": {
        border: "none", // Remove on focus
        },
    },
    "& .MuiInputBase-root": {
        "&:before, &:after": {
        borderBottom: "none", // Remove underline for standard/filled
        },
        "&:hover:not(.Mui-disabled):before": {
        borderBottom: "none",
        },
    },
}

export const NUMERIC_FIELDS_DISABLE_ARROW_STYLE = {
  // Chrome, Safari, Edge, Opera
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  // Firefox
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
}
